<!--
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-05-27 09:48:02
 -->
<template>
  <div>
    <el-header id="header">
      <span class="hideAside" @click="collapse"><i class="fa fa-indent fa-lg"></i></span>
      <span class="title_" style='font-size:22px;letter-spacing: 3px;color:white;'>天然气运营管理系统<span v-if="env=='production'&&isTest" style="font-size: 15px">(测试)</span></span>
      <ul class="personal">
        <li class="fullScreen" @click="fullScreen">
          <el-tooltip class="item" effect="dark" content="全屏" placement="bottom"><i
            class="fa fa-arrows-alt fa-lg"></i></el-tooltip>
        </li>

        <!--切换系统-->
        <li>
          <el-dropdown @command="handleCommand" style='color:white;'  placement="bottom">
            <span class="el-dropdown-link"><i class="fa fa-lg fa-th-list" style="font-size: 15px;" ></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="gas">数据采集管理系统</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <!-- 待办事项 -->
        <li class="notice" v-if="false">
          <el-popover
            placement="bottom"
            width="300"
            :disabled="!(noticeList != null && noticeList.length > 0)"
            trigger="click">
            <div class="noticeOne noticeTitle">
              <span class="noticeName">数据类型</span>
              <span class="noticeType">提醒内容</span>
            </div>
            <div v-if="noticeList && noticeList.length > 0">
              <div v-for="(item , index) in noticeList " :key="index">
                <div class="noticeOne noticeOneBack" @click="toPage(item.itemCode,item.remindId)">
                  <span class="noticeName">{{codeDict[item.code] }}</span>
                  <span class="noticeType">'{{ item.companyShortName }}' {{  statiTypeDict[item.itemCode] }}</span>
                </div>
              </div>
            </div>
            <div v-else style="text-align: center;padding: 10px;">
              暂无数据
            </div>
            <el-badge :value="noticeNum" slot="reference" :hidden="noticeHide">
              <i class="fa fa-bell" aria-hidden="true" @click="updateState"></i>
            </el-badge>
          </el-popover>
        </li>

        <!-- <li>
          <langSelect></langSelect>
        </li> -->
        <!-- <li>{{ $t(`role.${this.$store.getters.info.role}`) }}</li> -->
        <li>{{ this.$store.state.companyShortName }}{{departName?('  —  '+  departName):''}}</li>
        <li style="margin-right: 0;">
          <el-popover
            placement="bottom"
            width="320"
            trigger="hover">
            <div class="totalPoint">
              <h3>绩效</h3>
              <div >
                <strong class="cursor" @click="toPerson(true)">本周：{{obj.weekScore!=null?obj.weekScore:'--'}}分</strong>
                <span :class="{'red':Number(obj.weekDiffer)>=0}">{{obj.weekRank!=null?obj.weekRank:'--'}}位
                   <i v-if="Number(obj.weekDiffer)>0" class="el-icon-top"></i>
                  <i v-if="Number(obj.weekDiffer)<0" class="el-icon-bottom"></i>
                  {{obj.weekDiffer?obj.weekDiffer:'--'}}</span>
                 <star v-if="showStar" :starTotalNum="obj.weekStar"></star>
              </div>
              <div >
                <strong class="cursor" @click="toPerson(false)">本月：{{obj.monthScore!=null?obj.monthScore:'--'}}分</strong>
                <span :class="{'red':Number(obj.monthDiffer)>=0}">{{obj.monthRank!=null?obj.monthRank:'--'}}位
                  <i v-if="Number(obj.monthDiffer)>0" class="el-icon-top"></i>
                  <i v-if="Number(obj.monthDiffer)<0" class="el-icon-bottom"></i>
                  {{obj.monthDiffer?obj.monthDiffer:'--'}}</span>
                <star v-if="showStar" :starTotalNum="obj.monthStar"></star></div>
              <div class="flexb"><el-button size="small" @click="changePassword">修改密码</el-button><el-button @click="loginOut" size="small">退出登录</el-button></div>
            </div>
            <span class="el-dropdown-link" slot="reference">
                  <star v-if="showStar" :starTotalNum="obj.yearStar"></star> {{this.$store.state.staffName}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
          </el-popover>
          <!--<el-dropdown @command="handleCommand" style='color:white;'>
                  <span class="el-dropdown-link">
                   {{this.$store.state.staffName}}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
                  </span>
            <el-dropdown-menu slot="dropdown">
              &lt;!&ndash; <el-dropdown-item command="a">{{ $t('userDropdownMenu.basicInfor') }}</el-dropdown-item> &ndash;&gt;
              <el-dropdown-item command="b">{{ $t('userDropdownMenu.changePassword') }}</el-dropdown-item>
              <el-dropdown-item command="logout" divided>{{ $t('userDropdownMenu.logout') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>-->
        </li>
      </ul>
    </el-header>
    <tabNav></tabNav>
    <el-dialog  :close-on-click-modal="false" title="重置密码"   :visible.sync="formDialog"  v-el-drag-dialog width="600px" >
      <el-form label-width="110px" :model="form" :rules='newPassword' ref='form' @submit.native.prevent @keyup.enter.native='onSubmit("form")'>
        <el-form-item prop='loginPwd' label-width="0">
          <el-input :type="typeP" v-model="form.loginPwd" placeholder="请输入新密码" maxlength="20" minlength="6">
            <template slot="append" >
              <i :class="typeIcon" @click="changType" style="font-size: 20px;cursor: pointer;"></i>
              <!--<i @click="changType" class="el-icon-view" :style=" 'font-size: 20px;cursor: pointer;color:' + typeColor +';'" ></i>-->
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formDialog = false">取 消</el-button>
        <el-button type="primary" @click='onSubmit("form")'>提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import star from '../../performance/components/star'
  import langSelect from '../../../components/lang/langSelect'
  import tabNav from './tabNav'
  import store from "../../../vuex";

  export default {
    name: 'Header',
    components: {tabNav, langSelect,star},
    data () {
      return {
        remindIdList:[],
        showStar:false,
        isTest:false,
        obj:{
          "weekScore": null,
          "monthScore": null,
          "weekRank": null,
          "weekDiffer": null,
          "monthRank": null,
          "monthDiffer": null,
          "weekStar": null,
          "monthStar": null
        },
        codeDict: {
          '1': '合同',
          '2': '结算',
        },
        statiTypeDict: {
          '1': '近7日新增合同',
          '2': '本月已调价',
          '3': '本月条款发生变化',
          '51': '由于市场变化需调价',
          '52': '由于用量不足需调价',
          '53': '由于用量不足需收租金',
          '54': '有合同到期',
          '55': '需退保证金的合同',
          '99': '有自定义提醒信息'
        },
        isfullScreen: true,
        avatar: './static/images/va.jpg',
        noticeList: [],
        formDialog: false,
        departName: localStorage.getItem('departName'),
        newPassword:{
          loginPwd:[
            {required: true, trigger: "blur", message: "请输入新密码"},
            { pattern:/^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,20}$/, message: '密码必须8-20位：字母 + 数字 组合'}
          ],
        },
        typeP: 'password',
        form: {
          loginPwd:''
        },
        portValue:''
      }
    },
    computed: {
      env(){
        return process.env.NODE_ENV
      },
      noticeHide () {
        if (this.noticeNum === 0 || this.noticeNum === '0'|| this.noticeNum === ''|| this.noticeNum === undefined|| this.noticeNum === null) {
          return true
        } else {
          return false
        }
      },
      noticeNum () {
        return this.$store.state.noticeNum
      },
      typeIcon () {
        return this.typeP === 'password'? 'el-icon-deytview':'el-icon-deytview_off '
      }
    },
    mounted() {
      let vm = this;
      let host = window.location.host,httpData = host.split(":"),protocol = window.location.protocol;
      let portHttp = vm.$Util.isEmpty(httpData) ? '':httpData[0];
      if(host.indexOf('192.168.1.245') >= 0){
        /*测试环境*/
        this.isTest=true;
        vm.portValue = protocol+"//"+(!vm.$Util.isEmpty(portHttp) ? portHttp+':9990':'');

      }else if(host.indexOf('gas.deyt.cn') >= 0){
        /*正式环境*/
        vm.portValue =  protocol+'//iot.deyt.cn';
      }else{
        /*开发*/
        vm.portValue = protocol+"//"+(!vm.$Util.isEmpty(portHttp) ? portHttp+':8080':'');
      }
      /*if(host.indexOf('gas.deyt.cn') < 0){
        this.isTest=true;
      }*/
     //this.getPersonSorce()
    },
    methods: {
      //跳转个人扣分页面
      toPerson(type){
        this.$router.push({name:'personPointDetail',query:{isWeek:type,week:this.obj.week}})
      },
      // 获取个人分数及排名
      getPersonSorce(){
       this.$axios.get(this.api.kpi.staffCurrent).then(res=>{
         if(res.data.code==200){
            this.obj = res.data.result;
           this.showStar=true;
         }
       })
      },
      collapse () {
        this.$store.dispatch('collapse')
      },
      fullScreen () {
        if (this.isfullScreen) {
          var docElm = document.documentElement
          if (docElm.requestFullscreen) {
            docElm.requestFullscreen()
          } else if (docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen()
          } else if (docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen()
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen()
          }
          this.isfullScreen = false
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen()
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen()
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
          }
          this.isfullScreen = true
        }
      },
      // 修改密码
      changePassword(){
        this.formDialog = true
        this.form.loginPwd = ''
        this.$nextTick(()=>{
          this.$refs['form'].clearValidate();
        })
      },
      // 推出登录
       loginOut(){
        localStorage.clear();
        sessionStorage.clear();
         this.$router.push({path:'/login'})
        // sessionStorage.removeItem('tabnavBox');
        location.reload()
      },
      handleCommand (command) {
        if (command === 'logout') {
          localStorage.clear();
          sessionStorage.clear();
          // sessionStorage.removeItem('tabnavBox')
          location.reload()
        } else if (command === 'b') {
          this.formDialog = true
          this.form.loginPwd = ''
          this.$nextTick(()=>{
            this.$refs['form'].clearValidate();
          })
        }else if(command === 'gas'){
          let timep=new Date().getTime();
          let vm = this;
          let url =  vm.portValue+'/#/index?isLink=true&time='+timep;
          window.open(url, '_blank')
        }
      },
      toPage (type,remindId) { // 点击每条信息
      console.log(this.$route.name=='pending')
      this.$router.push({
        name: "pending",
      });
    //  if(this.$route.name!='pending'){
    //     if(type==51||type==52||type==53||type==54||type==99){

    //     this.$router.push({
    //     name: "pending",
    //     query: { remindId:remindId},
    //   });
    //   }
    //  }else{
    //    this.$store.dispatch('setRemindId',remindId)
    //    console.log( this.$store.state.remindId)

    //   }

      },
      initData () { // 初始化数据
        this.$axios.post( this.api.base.remList, {}).then(res => {
          if(res.data.code === 200){
            // 未读数量
            this.$store.dispatch('setNoticeNum', res.data.data.total)
            this.noticeList = res.data.data.remindSellContItemResultVOS?res.data.data.remindSellContItemResultVOS:[];
            this.remindIdList = [];
             for (let i = 0; i < this.noticeList.length; i++) {
            this.remindIdList = this.remindIdList.concat(this.noticeList[i].remindId);
        }
          }
        });
      },
      updateState () { // 更新状态
        this.$axios.post( this.api.base.remUpdate,{remindIds: this.remindIdList}).then(res => {
          if(res.data.code === 200){
            this.$store.dispatch('setNoticeNum', '0')
          }
        });
      },
      changType () {
        if (this.typeP === 'password') {
          this.typeP = 'text'
        } else {
          this.typeP = 'password'
        }
      },
      onSubmit (form) { // 重置密码
        this.$refs[form].validate((valid) => {
          if (valid) {
            this.$axios.post( this.api.base.updateInfo, this.form).then(res => {
              if(res.data.code === 200){
                this.$message({
                  message: res.data.msg,
                  type: 'success',
                  offset:'360'
                });
                this.formDialog = false;
              }
            });
          }
        })
      },
    },
    created () {
      this.initData()
    }
  }
</script>
<style lang="scss" scoped>
.totalPoint{
  padding: 0 20px 20px;
  h3{margin:0 0 15px 70px;font-size: 16px }
  strong{margin-bottom: 15px;display: inline-block;font-size: 18px}
  span{color: #5daf34;margin-left: 20px}
  .red{color: red}
}
  .flexb{display: flex;justify-content: space-between;}
</style>
<style lang="scss">
//   .el-tree-node__content{

//     width:126px;
// }


  $top: top;
  $bottom: bottom;
  $left: left;
  $right: right;
  $leftright: ($left, $right);
  %w100 {
     width: 100%;
   }

  %h100 {
     height: 100%;
   }

  %cursor {
     cursor: pointer;
   }

  html, body, #app, .el-container, #asideNav, ul.el-menu {
  @extend %h100;
  }

  @mixin set-value($side, $value) {
    @each $prop in $leftright {
      #{$side}-#{$prop}: $value;
    }
  }

  /deep/ .el-form-item__content {
    margin-left: 0px !important;
    }
  .noticeTitle {
    list-style: none;
    line-height: 22px;
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #254282 ;
    cursor: pointer;
    outline: 0;
  }

  .noticeOneBack:hover {
    background-color: #f5f5f6;
    color: #369;
  }

  .noticeOne {
    cursor: pointer;
    padding: 3px;
    white-space:nowrap;
    display: flex;
  .noticeName {
    flex: 1;
    font-weight: 600;
    margin-right: 10px;
    overflow: hidden;
  }
  .noticeType {
    flex: 3;
    overflow: hidden;
  }
  }

  #header {
    color: white;
    background: rgb(3, 21, 42);
    max-height: 50px;
    line-height: 50px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
    display: flex;
    justify-content: space-between;
    .hideAside {
      @extend %cursor;
      .allTitle {
        margin-left: 20px;
        font-size: 20px;
        font-weight: 600;
      }
    }
  .personal {
    display: flex;
    flex-direction: row;
  li {
  @include set-value(margin, 13px);
    font-size: 12px;
  }
  .fullScreen {
  @extend %cursor;
  }
  .el-badge__content{
    border: 0 ! important;
  }
  .notice {
    cursor: pointer;
  .is-fixed {
    top: 16px !important;
    right: 8px !important;
  }
  }
  .el-dropdown-link {
  @extend %cursor;
  }
  .icon img {
    margin-#{$top}: 7px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    width: 40px;
    height: 40px;
  }
  }
  }
</style>



// WEBPACK FOOTER //
// src/pages/layout/header/header.vue